import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from './components/Loadable';
import Loading from './components/Loading';
import { MainLayout } from './layouts';

// Lazy-loaded components remain the same
const Home = Loadable(lazy(() => import('./pages/Home')));
const InquiryDetail = Loadable(lazy(() => import('./pages/InquiryDetail')));
const Notifications = Loadable(lazy(() => import('./pages/Notifications')));
const NotificationDetail = Loadable(lazy(() => import('./pages/NotificationDetail')));
const PostDetail = Loadable(lazy(() => import('./pages/PostDetail')));
const MyPosts = Loadable(lazy(() => import('./pages/MyPosts')));
const Profile = Loadable(lazy(() => import('./pages/Profile')));
const Tasks = Loadable(lazy(() => import('./pages/Tasks')));
const TaskDetail = Loadable(lazy(() => import('./pages/TaskDetail')));
const ContactAdmin = Loadable(lazy(() => import('./pages/ContactAdmin')));

const routes = [
  {
    path: 'error',
    element: <ContactAdmin />,
  },
  {
    path: '',
    // Wrap the protected area with MsalAuthenticationTemplate
    // instead of Okta's RequiredAuth or Security wrapper
    element: (
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} loadingComponent={() => <Loading />}>
        <MainLayout />
      </MsalAuthenticationTemplate>
    ),
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'search',
        children: [{ path: '', element: <Home /> }],
      },
      {
        path: 'posts',
        children: [
          { path: '', element: <MyPosts /> },
          { path: ':id', element: <PostDetail /> },
        ],
      },
      {
        path: 'comments',
        children: [{ path: '', element: <MyPosts /> }],
      },
      {
        path: 'inquiries',
        children: [
          { path: '', element: <MyPosts /> },
          { path: ':id', element: <InquiryDetail /> },
        ],
      },
      {
        path: 'tasks',
        children: [
          { path: '', element: <Tasks /> },
          { path: ':id', element: <TaskDetail /> },
        ],
      },
      {
        path: 'notifications',
        children: [
          { path: '', element: <Notifications /> },
          { path: ':id', element: <NotificationDetail /> },
        ],
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export default routes;
